import {
    getList,
    getItem,
    putItem,
    postItem
} from "./utils/entity-network-requests"

const entityName = "user"

export const getUserList = (token, parameters) =>
    getList(entityName, parameters, token)
export const getUserItem = (token, id) => getItem(entityName, id, token)
export const putUserItem = (token, id, user) =>
    putItem(entityName, id, user, token)
export const postUserItem = (token, user) => postItem(entityName, user, token)
